// extracted by mini-css-extract-plugin
export default {"root":"root--BjMlQ","btn":"btn--KStPa"};